const robotChat = r => require.ensure([], () => r(require('@/views/robot-chat'), 'robotChat'))

export default {
  path:'/robot-chat',
  name:'robotChat',
  component: robotChat,
  meta: { title: '聊天机器人', keepAlive:true }
}


// WEBPACK FOOTER //
// ./src/views/robot-chat/router.js